import { useEffect, useState } from "react";
import Company from "./Company";
import axios from "../api/axios";
import jwt_decode from "jwt-decode";

export default function CompanyList(props) {
  const GET_COMPANIES_URL = `/company/list?page=${props.pageno}&limit=10`;
  const TOTAL_COMPANIES_URL = `/company/total`;
  const COMPANY_NAME_URL = `/company/filter/company_list`;

  const [companies, setCompanies] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [totalcompanies, setTotalCompanies] = useState(0);

  const decode = jwt_decode(window.localStorage.accessToken);

  useEffect(() => {
    fetchCompanyNames();
    fetchTotalCompanies();

    if (!props.filter.filter) {
      fetchCompanies();
    } else {
      filterCompanies();
    }
  }, [props.pageno, props.one]);

  const fetchCompanyNames = async () => {
    const res = await axios.get(COMPANY_NAME_URL);
    setCompanyName(res.data.companies);
  };

  const fetchCompanies = async () => {
    const res = await axios.post(GET_COMPANIES_URL);
    setCompanies(res.data.results.companies);
  };

  const filterCompanies = async () => {
    const res = await axios.post(GET_COMPANIES_URL, {
      role: decode.role,
      filter: props.filter.filter,
      filterCompanyName: props.filter.company,
      filterOwnerName: props.filter.ownwername,
      filterCity: props.filter.city,
    });
    setCompanies(res.data.results.companies);
  };

  const fetchTotalCompanies = async () => {
    const res = await axios.get(TOTAL_COMPANIES_URL);
    setTotalCompanies(res.data.totalCompanies);
  };

  props.settotal(totalcompanies);
  props.companyName(companyName);

  let number = 0;
  let number1 = props.pageno > 1 ? (props.pageno - 1) * 10 : 0;

  return companies.map((company) => {
    number++;
    return (
      <Company
        key={company._id}
        number={number + number1}
        adminID={decode.id}
        id={company._id}
        name={company.name}
        owner={company.ownerFirstName + " " + company.ownerLastName}
        city={company.city}
        addresses={company.address}
        state={company.state}
        email={company.email}
        domain={company.domain}
        zip={company.zip}
        phone={company.phone}
        script={company.scriptURL}
        ownerFirstName={company.ownerFirstName}
        ownerLastName={company.ownerLastName}
        logo={company?.logo}
        chatbotsModuleEnabled={company.chatbotsModuleEnabled}
        maxChatbotsAllowed={company.maxChatbotsAllowed}
        chatbotPlan={company.chatbotPlan}
        voiceAssistantModuleEnabled={company.voiceAssistantModuleEnabled}
        maxVoiceAssistantsAllowed={company.maxVoiceAssistantsAllowed}
        voiceAssistantPlan={company.voiceAssistantPlan}
        voiceMaxCallsPerDay={company.voiceMaxCallsPerDay}
        voiceMaxTokensPerDay={company.voiceMaxTokensPerDay}
        voiceMaxConcurrentCalls={company.voiceMaxConcurrentCalls}
        voiceMaxCallDurationSeconds={company.voiceMaxCallDurationSeconds}
        voiceMaxTTSCharsPerDay={company.voiceMaxTTSCharsPerDay}
        voiceMaxSTTSecondsPerDay={company.voiceMaxSTTSecondsPerDay}
        voiceUsageWarningThresholdPct={company.voiceUsageWarningThresholdPct}
        voiceRecordingEnabled={company.voiceRecordingEnabled}
        voiceModuleSuspended={company.voiceModuleSuspended}
        voiceModuleSuspendedReason={company.voiceModuleSuspendedReason}
      />
    );
  });
}